import request from '@/utils/request'

export async function getData(params) {
  return request({
    url: '/statistics/person/counts',
    method: 'get',
    params,
  })
}
export async function exportReport(params) {
  return request({
    url: '/statistics/person/countsExport',
    method: 'get',
    params,
  })
}
